import {MainSystemRules} from './main-system-rules';
import {TractionSystemRules} from './traction-system-rules';
import {SignalizationSystemRules} from './signalization-system-rules';
import {CommunicationSystemRules} from './communication-system-rules';
import {BrakeSystemRules} from './brake-system-rules';
import {PowerVoltageSystemRules} from './power-voltage-system-rules';
import {AirConditionSystemRules} from './air-condition-system-rules';
import {DoorSystemRules} from './door-system-rules';
import {OtherSystemRules} from './other-system-rules';
import {Rule} from '../../models/svg-rule/rule.model';
import {TcddSubSystem} from '../../enums/tcdd-sub-system.enum';

/**
 * Interface for grouping rules by system.
 */
interface Rules {
  [TcddSubSystem.MAIN_SYSTEM]: Rule[];
  [TcddSubSystem.TRACTION_SYSTEM]: Rule[];
  [TcddSubSystem.SIGNALIZATION_SYSTEM]: Rule[];
  [TcddSubSystem.COMMUNICATION_SYSTEM]: Rule[];
  [TcddSubSystem.BRAKE_SYSTEM]: Rule[];
  [TcddSubSystem.POWER_VOLTAGE_SYSTEM]: Rule[];
  [TcddSubSystem.AIR_CONDITION_SYSTEM]: Rule[];
  [TcddSubSystem.DOOR_SYSTEM]: Rule[];
  [TcddSubSystem.OTHER_SYSTEM]: Rule[];
}

export class SvgTcddTrainRules {
  public static getRules(): Rules {
    return {
      [TcddSubSystem.MAIN_SYSTEM]: new MainSystemRules().getRules(),
      [TcddSubSystem.TRACTION_SYSTEM]: new TractionSystemRules().getRules(),
      [TcddSubSystem.SIGNALIZATION_SYSTEM]: new SignalizationSystemRules().getRules(),
      [TcddSubSystem.COMMUNICATION_SYSTEM]: new CommunicationSystemRules().getRules(),
      [TcddSubSystem.BRAKE_SYSTEM]: new BrakeSystemRules().getRules(),
      [TcddSubSystem.POWER_VOLTAGE_SYSTEM]: new PowerVoltageSystemRules().getRules(),
      [TcddSubSystem.AIR_CONDITION_SYSTEM]: new AirConditionSystemRules().getRules(),
      [TcddSubSystem.DOOR_SYSTEM]: new DoorSystemRules().getRules(),
      [TcddSubSystem.OTHER_SYSTEM]: new OtherSystemRules().getRules()
    };
  }
}
